<ng-container *ngIf="selectedItemData">
    <!-- Avallain - scoreable/non-scoreable and non-avallain games launch using xapirunner -->
    <div [hidden]="!contentHelper.isXapiContent(selectedItemData)" id="content-course-ext"
        [class.game-background]="selectedItemData['game']">
        <!--Activity Item will launch here.-->
    </div>

</ng-container>

<button class="btn" [hidden]="true" data-toggle="modal" data-target="#saveAlertModal" #showSaveAlertModalBtn>Show Alert</button>
<save-alert ></save-alert>